<div>
  <mat-card>
    <mat-card-header>In the end</mat-card-header>
    <mat-list >
      <mat-list-item> Remaining debt: {{remainingDebt}}</mat-list-item>
      <mat-list-item> Interest payed: {{interestPayed}}</mat-list-item>
      <mat-list-item> Principal payed: {{principalPayed}}</mat-list-item>
      <mat-list-item> Premium Payed: {{premiumPayed}}</mat-list-item>
    </mat-list>
  </mat-card>
</div>
